import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import CommunityComponent from "../../components/community/community-news";
import routes from "../../constants/routes";
import ArticleComponent from "../../components/community/article";

function CommunityPage() {
  const location = useLocation();

  // Determine which component to render based on the current route
  let ComponentToRender;
  switch (location.pathname) {
    case routes.community:
      ComponentToRender = CommunityComponent;
      break;
    case routes.communityArticle:
      ComponentToRender = ArticleComponent;
      break;
    default:
      ComponentToRender = () => <div>Page Not Found</div>; // Optional fallback
      break;
  }

  return (
    <Box>
      <ComponentToRender />
    </Box>
  );
}

export default CommunityPage;
